import { StrictMode, useEffect, useState } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { WagmiProvider } from "wagmi";
import { wagmiConfig } from "./wallet/config";
import { loadSdk } from "./sdk";
import { applyTheme, prefs } from "./state/prefs";
import { App } from "./App";
import "./styles/tokens.css";
import "./styles/app.css";
import "./styles/components.css";
import "./styles/layout.css";

const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: 1, refetchOnWindowFocus: false } },
});

applyTheme(prefs.get().theme);

/** Nothing renders until the SDK is loaded: every figure and signature is its. */
function Boot() {
  const [state, setState] = useState<"loading" | "ready" | Error>("loading");
  useEffect(() => {
    loadSdk().then(
      () => setState("ready"),
      (error: unknown) => setState(error instanceof Error ? error : new Error(String(error))),
    );
  }, []);
  if (state === "ready") return <App />;
  return (
    <div className="boot">
      <div className="stack-sm" style={{ alignItems: "center" }}>
        <div className="boot-mark">
          papertrade<span>_</span>
        </div>
        {state instanceof Error && (
          <p className="muted" role="alert">
            This browser could not start the trading engine: {state.message}
          </p>
        )}
      </div>
    </div>
  );
}

const root = document.getElementById("root");
if (!root) throw new Error("#root is missing from index.html");

createRoot(root).render(
  <StrictMode>
    <WagmiProvider config={wagmiConfig}>
      <QueryClientProvider client={queryClient}>
        <Boot />
      </QueryClientProvider>
    </WagmiProvider>
  </StrictMode>,
);
